import ContentHeader from 'components/ContentHeader'
import React from 'react'
import MainContainer from 'theme/MainConatiner'
import "./style.css";
import { useOutletContext } from 'react-router-dom';
import { Table } from 'components/DataTable/Table';

const UserListContainer = (props) => {
    const { handleDrawerToggle } = useOutletContext();

    return (
        <>
            <ContentHeader
                title={"Users"}
                backButton={false}
                handleDrawerToggle={handleDrawerToggle}
            />
            <MainContainer>
                <Table {...props}/>
            </MainContainer>
        </>
    )
}

export default UserListContainer
